import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Image } from '../Image/Image.js';
import { Text } from '../Text/Text.js';

const GoogleStars = ({
  theme = 'light'
}) => {
  return jsxs("div", {
    className: "flex items-center",
    children: [jsxs("div", {
      className: "relative mr-xs w-[127px]",
      children: [jsx(Image, {
        src: "/icons/5_stars.svg",
        alt: "4.7 Stars"
      }), jsx("div", {
        className: "absolute inset-y-0 right-0 w-[8px] opacity-60"
      })]
    }), jsx(Text, {
      variant: "h3",
      fontWeight: "semibold",
      className: clsx({
        'text-navy': theme === 'light',
        'text-white': theme === 'dark'
      }),
      children: "on"
    }), jsx("div", {
      className: "ml-xs w-3xl",
      children: jsx(Image, {
        src: "/logos/google_logo.svg",
        alt: "Google"
      })
    })]
  });
};

export { GoogleStars };
